import { render, staticRenderFns } from "./PMenu.vue?vue&type=template&id=ece7b93c&scoped=true&"
import script from "./PMenu.vue?vue&type=script&lang=js&"
export * from "./PMenu.vue?vue&type=script&lang=js&"
import style0 from "./PMenu.vue?vue&type=style&index=0&id=ece7b93c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7b93c",
  null
  
)

export default component.exports